import { render, staticRenderFns } from "./replace-manager.vue?vue&type=template&id=5761d960&"
import script from "./replace-manager.vue?vue&type=script&lang=js&"
export * from "./replace-manager.vue?vue&type=script&lang=js&"
import style0 from "./replace-manager.vue?vue&type=style&index=0&id=5761d960&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports